<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>시스템 관리</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">시스템 관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">메뉴 접속 통계</p>
          <ul class="depth">
            <li><router-link to="/usermanagement" title="사용자관리">사용자관리</router-link></li>
            <li><router-link to="/teamlist" title="팀관리">팀관리</router-link></li>
            <li><router-link to="/departmentlist" title="부서관리">부서관리</router-link></li>
            <li><router-link to="/menulist" title="메뉴관리">메뉴관리</router-link></li>
            <li><router-link to="/userauthoritylist" title="사용자권한관리">사용자권한관리</router-link></li>
            <li><router-link to="/accessinfo" title="접속정보">접속정보</router-link></li>
            <!-- <li><router-link to="/connertmenustat" title="메뉴접속통계">메뉴접속통계</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">메뉴 접속 통계</h3>
        <article class="selectOpt">
          <dl>
            <dt>조회기간</dt>
            <dd>
              <date-picker></date-picker>
              <button type="button" class="btn dkGray">조회</button>
            </dd>
          </dl>
        </article>
        <article>
          <div class="searchArea">
            <div class="total">총<span>1260</span>건</div>
          </div>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table vertical-table">
              <table>
                <caption>
                  메뉴 접속 통계 테이블
                </caption>
                <thead>
                  <tr>
                    <th scope="col">번호</th>
                    <th scope="col">메뉴명</th>
                    <th scope="col">URL</th>
                    <th scope="col">접속횟수</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in 10" :key="index">
                    <td>1</td>
                    <td>공영주차장 > 안내</td>
                    <td>/parking/introduce.do</td>
                    <td>10</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 페이지네이션 -->
          <v-pagination v-model="curPageNum" :length="numOfPages"></v-pagination>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from 'axios';
import DatePicker from '../../../components/DatePicker2.vue';

export default {
  data() {
    return {
      listData: [],
      curPageNum: 1,
      dataPerPage: 10,
    };
  },

  components: {
    DatePicker,
  },

  mounted() {},

  methods: {},

  computed: {
    numOfPages() {
      return Math.ceil(this.listData.length / this.dataPerPage);
    },
  },
};
</script>
